












































import { Vue, Component } from "@/shared/vuepack";
import { useAdminHsaStoreInfoStore } from "@/admin/store/hsaStoreInfo";
import EditDefaultHsaStoreInfo from "./EditDefaultHsaStoreInfo.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import * as RouteNames from "@/admin/route-names";
import { UserPermission } from "@/shared/types";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

@Component({
  components: {
    EditDefaultHsaStoreInfo
  }
})
export default class AdminHsaStoreDefaultConfiguration extends Vue {
  adminHsaStoreInfoStore = useAdminHsaStoreInfoStore();
  notifierStore = useNotifierStore();
  isSubmitting = false;
  hasViewPermission = true;
  hasEditPermission = false;
  RouteNames = RouteNames;
  rolePermissionsStore = useRolePermissionsStore();

  mounted () {
    this.adminHsaStoreInfoStore.loadDefaultStoreInfos();
    this.hasViewPermission = this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalMarketplaceTileView);
    this.hasEditPermission = this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalMarketplaceTileEdit);
  }

  get stores () {
    return this.adminHsaStoreInfoStore.getDefaultHsaStoreInfos();
  }
}
